import {Alert as MUIAlert} from '@mui/material'
import React from 'react'

interface AlertProps extends React.ComponentProps<typeof MUIAlert> {}

export const Alert: React.FC<AlertProps> = (props) => {
  return <MUIAlert {...props} />
}
